import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { HomeComponent } from './home.component';
import { homeRoutingoModule } from './home-routing.module';
import { SlickCarouselModule } from 'ngx-slick-carousel';
@NgModule({
  imports: [
    homeRoutingoModule,
    HttpClientModule,
    CommonModule,
    SlickCarouselModule,
    LoadingModule

  ],
  declarations: [HomeComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class homeModule { }
